import { AnimatePresence } from 'framer-motion';
import { RealImpact } from './RealImpact';
import { RealResults } from './RealResults';
import { HowOathWorks } from './HowOathWorks';
import { OurAlgorithm } from './OurAlgorithm';
import { ENV_CONFIG } from 'config/environment';
import { ImpactRatings } from './ImpactRatings';
import { Quote } from 'components/LottieElements/Quote';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';

export const ImpactScoreScreen = () => {
  return (
    <HeaderAndFooterLayout
      footerVisible={true}
      headerVisible={true}
      isLoading={false}
      hasIssues={true}
    >
      <AnimatePresence>
        <HowOathWorks />
        <ImpactRatings />
        <OurAlgorithm />
        <RealImpact />
        <RealResults />
        <Quote
          text="“Testimonial from Dante Pittman or someone from his team, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam!”"
          name="Rep. Dante Pittman"
          role="North Carolina, District 24"
          image={`${ENV_CONFIG().CLOUD_STORAGE.URL}/headshots/alan.jpeg`} // TODO: Change to actual graphic
        />
      </AnimatePresence>
    </HeaderAndFooterLayout>
  );
};
